import VueRouter from 'vue-router';
import Booking from '../global/booking/vue/booking';
// import HomePage from '../global/Home';
import Direction from '../global/Direction';
import Aboutus from '../global/aboutus';
import GiftCard from '../global/giftcard/giftcard';

const routes = [
	{
        path: '/', 
        name: 'Booking',
        component: Booking
	},
	// {
        // path: '/booking',
        // name: 'Booking',
        // component: Booking
	// },
	{
        path: '/direction',
        name: 'Direction',
        component: Direction
	},
	{
        path: '/aboutus',
        name: 'Aboutus',
        component: Aboutus
	},
	{
        path: '/giftcard',
        name: 'GiftCard',
        component: GiftCard
	}
];

export default new VueRouter({
  base: window.base_url,
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 }
  }
});
